import type { TFunction } from 'i18next';
import { getMetadataString } from '../helpers/purchase-order-activity-metadata';
import type { PurchaseOrderActivityItem } from '../types/purchase-order-activity-item';
import { PurchaseOrderActivityDocumentBadge } from './purchase-order-activity-document-badge';

type PurchaseOrderActivityDocumentDeletedProps = {
  activity: PurchaseOrderActivityItem;
  t: TFunction<'purchaseOrder'>;
};

export function PurchaseOrderActivityDocumentDeleted({
  activity,
  t,
}: PurchaseOrderActivityDocumentDeletedProps) {
  const documentName = getMetadataString(activity.metadata, 'documentName');
  const documentTypeCode = getMetadataString(
    activity.metadata,
    'documentTypeCode',
  );
  const reason =
    getMetadataString(activity.metadata, 'reason') ?? activity.oldValue;

  return (
    <>
      <span className='font-semibold text-foreground'>
        {t('activity.document.deleted')}
      </span>
      {documentName ? (
        <span className='font-semibold text-primary underline underline-offset-2'>
          {documentName}
        </span>
      ) : null}
      {documentTypeCode ? (
        <PurchaseOrderActivityDocumentBadge
          documentTypeCode={documentTypeCode}
        />
      ) : null}
      {reason ? (
        <span className='text-foreground'>
          {t('activity.document.reason', { reason })}
        </span>
      ) : null}
    </>
  );
}
